import { useAtomValue } from 'jotai';

import {
  AudioRecordingState,
  cloudRecordingStatusAtom,
  isCloudRecordingActive,
  participantCountAtom,
  recordingStateAtom,
} from '../../video-sdk';

export function useRecordingControl(hasAppointment: boolean = false) {
  const recordingState = useAtomValue(recordingStateAtom).value;
  const cloudStatus = useAtomValue(cloudRecordingStatusAtom);
  const syncMapSaysRecording = recordingState === AudioRecordingState.RECORDING;
  const isRecording = cloudStatus !== null ? isCloudRecordingActive(cloudStatus) : syncMapSaysRecording;
  const inSession = !!useAtomValue(participantCountAtom);
  const isVisible = (inSession && hasAppointment) || isRecording;

  return {
    isVisible,
    isRecording,
    recordingState,
  };
}
